module.exports = __webpack_public_path__ + "static/img/bank-flow1.bd72b68d.jpg";